import Icon from '@ant-design/icons';
import { Button, Flex, Form } from 'antd';
import React from 'react';
import Dropzone from 'react-dropzone';
import CustomAttachmentIcon from '~/assets/svg/icon-attachment.svg?react';
import CustomFullscreenIcon from '~/assets/svg/icon-fullscreen.svg?react';
import CustomSendOutlineIcon from '~/assets/svg/icon-send-outline.svg?react';
import CustomSendIcon from '~/assets/svg/icon-send.svg?react';
import FullscreenEditorModal from '~/components/screens/Conversations/FullscreenEditorModal';
import SpellCheckerInput from '~/components/shared/SpellCheckerInput/SpellCheckerInput';
import { useMessageComposer } from '~/hooks/useMessageComposer';

import AttachmentPreview from './AttachmentPreview';
import TemplateSelector from './TemplateSelector';

function SendMessageForm({ mutation, formName = 'sendMessage', disabled = false, contactReason, activeMerchantId }) {
  const { form, editorRef, files, templates, selectedTemplateId, onDrop, removeFile, applyTemplate, onFinish, openModal, modalProps, MAX_SIZE_BYTES } =
    useMessageComposer({
      mutation,
      activeMerchantId,
    });

  const isSubmitting = mutation.isPending;
  const isDisabled = disabled || isSubmitting;

  const dropzoneButton = (className) => (
    <Dropzone onDrop={onDrop} disabledStyle={{}} maxSize={MAX_SIZE_BYTES} className={className}>
      <Button className='btn-icon' type='text' size='large'>
        <Icon component={CustomAttachmentIcon} />
      </Button>
    </Dropzone>
  );

  return (
    <Flex vertical gap={8} align='center' className='w-full'>
      <TemplateSelector templates={templates} contactReason={contactReason} selectedTemplateId={selectedTemplateId} onApplyTemplate={applyTemplate} />
      <Form form={form} name={formName} onFinish={onFinish} className='w-full'>
        <Flex gap={8}>
          <Form.Item name='content' className='grow w-full'>
            <SpellCheckerInput
              ref={editorRef}
              placeholder='Saisissez votre réponse'
              textArea
              suffix={
                <Button type='text' className='btn-icon' size='large' onClick={openModal}>
                  <Icon component={CustomFullscreenIcon} />
                </Button>
              }
            />
          </Form.Item>
          {dropzoneButton('h-fit')}
          <Form.Item noStyle>
            <Button type='primary' className='btn-icon btn-success' size='large' htmlType='submit' loading={isSubmitting} disabled={isDisabled}>
              {!isSubmitting && <Icon component={CustomSendIcon} />}
            </Button>
          </Form.Item>
        </Flex>
      </Form>

      <AttachmentPreview files={files} onRemoveFile={removeFile} className='max-w-[70vw]' />

      <FullscreenEditorModal
        {...modalProps}
        submitIcon={<Icon component={CustomSendOutlineIcon} />}
        loading={isSubmitting}
        disabled={isDisabled}
        footerExtra={dropzoneButton()}
      >
        <AttachmentPreview files={files} onRemoveFile={removeFile} />
        <TemplateSelector templates={templates} contactReason={contactReason} selectedTemplateId={selectedTemplateId} onApplyTemplate={applyTemplate} />
      </FullscreenEditorModal>
    </Flex>
  );
}

export default SendMessageForm;
